import { render, staticRenderFns } from "./FollowshipSolidBtn.vue?vue&type=template&id=305662cb&scoped=true&"
import script from "./FollowshipSolidBtn.vue?vue&type=script&lang=js&"
export * from "./FollowshipSolidBtn.vue?vue&type=script&lang=js&"
import style0 from "./FollowshipSolidBtn.vue?vue&type=style&index=0&id=305662cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305662cb",
  null
  
)

export default component.exports